var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 16.6667H36.6667C38.5 16.6667 40 15.1667 40 13.3333C40 11.5 38.5 10 36.6667 10H16.6667C13 10 10 13 10 16.6667V63.3333C10 67 13 70 16.6667 70H36.6667C38.5 70 40 68.5 40 66.6667C40 64.8333 38.5 63.3333 36.6667 63.3333H16.6667V16.6667Z",
    fill: "#161158"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8333 38.8333L59.5333 29.5333C59.3015 29.2952 59.0039 29.1316 58.6786 29.0636C58.3532 28.9955 58.015 29.0261 57.7072 29.1514C57.3993 29.2767 57.1358 29.491 56.9505 29.7669C56.7651 30.0427 56.6663 30.3676 56.6667 30.7V36.6667H33.3333C31.5 36.6667 30 38.1667 30 40C30 41.8333 31.5 43.3333 33.3333 43.3333H56.6667V49.3C56.6667 50.8 58.4667 51.5333 59.5 50.4667L68.8 41.1667C69.4667 40.5333 69.4667 39.4667 68.8333 38.8333Z",
    fill: "#161158"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.05c51bad76fa323592f1a5649314e312.svg";
export { ForwardRef as ReactComponent };